import { useTranslation } from 'react-i18next';

import { DISTANCES } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditDistances from './components/CreateEditDistances';

import useColumnDefinitions from './hooks/useColumnDefinitions';
import useGetDistancesTableData from './hooks/useGetDistancesTableData';

const Distances = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetDistancesTableData();
  const columnDefinitions = useColumnDefinitions();
  const { mutate: handleDeleteClick } = useDeleteById(DISTANCES, ['distances']);

  return (
    <TableCRUDLayout
      FormComponent={CreateEditDistances}
      loading={isFetching}
      columns={columnDefinitions}
      rows={data}
      getRowId={(row) => row.distanceId}
      onDeleteClick={handleDeleteClick}
      confirmationTitle={t('distances.deleteDistanceDialog.title')}
      confirmationBody={t('distances.deleteDistanceDialog.body')}
      customCreateTitle={t('distances.form.create')}
    />
  );
};

export default Distances;
